// extracted by mini-css-extract-plugin
export default {"copy":"VY8m9kf0bLDDA255wiHP"};